import { Ng2StateDeclaration } from '@uirouter/angular';
import { CompanyGroupCreateComponent } from './create.component';

export const companyGroupCreateState: Ng2StateDeclaration = {
    name: 'companyGroup-create',
    url: '/companyGroup/create',
    parent: '_screens',
    data: {
        authorities: [],
        pageTitle: 'company-groups.create.title',
    },
    views: {
        'content@': { component: CompanyGroupCreateComponent },
    },
};



// WEBPACK FOOTER //
// ./src/app/_screens/directory/group/create/create.state.ts